import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Form } from "react-bootstrap";
import { getDatabase, ref, set } from "firebase/database";
import { firebaseToString } from '../Tools/tools';

function EditarAluno(props) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [changed, setChanged] = useState(false);
    const [updatePath, setUpdatePath] = useState(false);

    useEffect(() => {
        const data = {
            old_path: props.data[0],
            path: props.data[0],
            id: props.data[1],
            nome: props.data[2],
            empresa: props.data[3],
            departamento: props.data[4],
        }
        setFormData(data)
        setOriginalData(data);
        setChanged(false)
        setUpdatePath(false)
    }, [props])

    const [formData, setFormData] = useState({});
    const [originalData, setOriginalData] = useState({});
    const [errors, setErrors] = useState({});

    const validate = () => {
        let newErrors = {};
        if (!formData.nome) newErrors.nome = "Nome é obrigatório";
        if (!formData.departamento) newErrors.departamento = "Departamento é obrigatório";
        if (!formData.empresa) newErrors.empresa = "Empresa é obrigatória";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            const newPath = `companies/${firebaseToString(formData.empresa)}/${firebaseToString(formData.departamento)}/${firebaseToString(formData.id)}`;
            const oldPath = `companies/${formData.old_path}`
            const db = getDatabase();

            set(ref(db, newPath), {
                NAME: firebaseToString(formData.nome)
            }).then(() => {
                if (updatePath) {
                    set(ref(db, oldPath), {})
                }
            }).finally(() => {
                handleClose();
            })
        }
    }

    return (
        <>
            <Button variant="primary" onClick={handleShow}>
                Editar
            </Button>

            <Form onSubmit={handleSubmit}>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Editar Aluno</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.nome}
                                onChange={(e) => {
                                    setChanged(e.target.value !== originalData.nome);
                                    setFormData({ ...formData, nome: e.target.value });
                                }}
                                isInvalid={!!errors.nome}
                            />
                            <Form.Control.Feedback type="invalid">{errors.nome}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Departamento</Form.Label>
                            <Form.Select
                                onChange={(e) => {
                                    setChanged(e.target.value !== originalData.departamento);
                                    setUpdatePath(e.target.value !== originalData.departamento);
                                    setFormData({ ...formData, departamento: e.target.value });
                                }}
                                isInvalid={!!errors.departamento}
                            >
                                <option>{formData.departamento}</option>
                                <option disabled className='text-secondary'>-----------------</option>
                                {
                                    props.departamentos.map((val) => {
                                        return (
                                            <option>
                                                {val}
                                            </option>
                                        )
                                    })
                                }
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">{errors.departamento}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Empresa</Form.Label>
                            <Form.Select
                                // onChange={(e) => setFormData({ ...formData, empresa: e.target.value })}
                                // isInvalid={!!errors.empresa}
                                disabled
                            >
                                <option >{formData.empresa}</option>
                                {
                                    Object.keys(props.empresas).map((val) => {
                                        return (
                                            <option>
                                                {val}
                                            </option>
                                        )
                                    })
                                }
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">{errors.empresa}</Form.Control.Feedback>
                        </Form.Group>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary" type="submit" onClick={handleSubmit} disabled={!changed}>
                            Salvar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Form>
        </>
    );
}

export default EditarAluno